import { Box, Icons } from '@vouched.id/vault';
import React, { useEffect, useState } from 'react';
import { Dropdown } from '../Dropdown';
import { DOBCaption } from './DOBCaption';
import { DOBCompletedResult } from './DOBCompletedResult';
import { useGlobalState } from 'store/reducers/reducer';
import { getDobJob } from 'store/sagas/sagas';
export const DOBDropdowns = ({ jobSid, jobStatus }) => {
    const { asyncDispatch } = useGlobalState();
    const [dobJob, setDobJob] = useState(null);
    useEffect(() => {
        asyncDispatch(getDobJob(jobSid)).then(setDobJob, console.error);
    }, [jobSid]);
    if (!dobJob)
        return (React.createElement(Dropdown, { title: "DOB" },
            React.createElement(Box, null,
                React.createElement(DOBCaption, null),
                React.createElement(Icons.Loading, null))));
    const { requestData, responseData, provider, status } = dobJob;
    return (React.createElement(DOBCompletedResult, { dobIsMatch: responseData.dobMatch, jobStatus: status, parentJobStatus: jobStatus, requestData: requestData, source: provider }));
};
